// Fish -------------------------------------------------------
function Fish(clr, delay, fixed) {

	//Import classes
	var Container = include('createjs.Container'),
		Sprite = include('createjs.Sprite'),
		Tween = include('createjs.Tween'),
		EventDispatcher = include('springroll.EventDispatcher');

	// parameters	
	this.clr = clr;	
	this.delay = delay;
	this.fixed = fixed;
	this.show_short = (this.delay > 500);
	
	// objects 
	this.view = new Container();
	this.ev_disp = new EventDispatcher();

	// set up function bindings
	this.startAnimation = this.startAnimation.bind(this);
	this.playBubbles = this.playBubbles.bind(this);
	
	this.init();
}

namespace('WGBH').Fish = Fish;

var p = Fish.prototype;

// used to initialize the button
p.init = function() {
	// add fish
	this.fish = new createjs.Sprite(LOADED_OBJECTS.sprsheets.fishanim_spr, (this.clr + '0'));
	this.fish.gotoAndStop(this.clr + '0');
	this.fish.scaleX = this.fish.scaleY = app.config.GAME.FISH.scaling.fish;
	this.view.addChild(this.fish);
	// add bubbles
	this.bubbles = new createjs.Sprite(LOADED_OBJECTS.sprsheets.bubbleanim_spr, 'end_anim');
	this.bubbles.x = app.config.GAME.FISH.bubbles.x;
	this.bubbles.y = app.config.GAME.FISH.bubbles.y;
	this.bubbles.scaleX = -app.config.GAME.FISH.scaling.bubbles;
	this.bubbles.scaleY = app.config.GAME.FISH.scaling.bubbles;
	this.view.addChild(this.bubbles);
	if(!this.fixed) {
		this.startAnimation();
	}
};

// used to start the animation with delay
p.startAnimation = function() {
	var fr_sel = 0;
	// make sure there's enough values to pick from
	if(app.fish_frames.length === 0) {
		app.fish_frames = app.config.GAME.ANIM.fish_fr.slice(0);
	}
	fr_sel = this.clr + app.fish_frames.splice(getRandomWholeNumber(0, app.fish_frames.length - 1), 1);
	this.fish.gotoAndPlay(fr_sel);
	// start timer for bubbles
	this.delay = app.config.GAME.ANIM.deltimes[getRandomWholeNumber(0, 5)];
	this.bubble_timer = new springroll.DelayedCall(this.playBubbles, this.delay, {repeat:false});	
};

// used to play the bubbles
p.playBubbles = function() {
	if(!this.show_short) {
		this.bubbles.gotoAndPlay('start_anim');	
		this.show_short = true;	
	}
	else {
		this.bubbles.gotoAndPlay('start_short_anim');			
		this.show_short = false;	
	}
	this.delay = app.config.GAME.ANIM.deltimes[getRandomWholeNumber(0, 5)];
	this.bubble_timer = new springroll.DelayedCall(this.playBubbles, this.delay, {repeat:false});	
};

// used to stop the animation of the fish
p.stopFishAnimation = function() {
	if(typeof this.bubble_timer !== 'undefined') {
		this.bubble_timer.destroy();	
	}
	this.fish.gotoAndStop(this.clr + '0');
};

// used to hide the fish
p.hideFish = function() {
	this.fish.alpha = 0;
};

// used to fade in the fish
p.fadeInFish = function(clr) {
	this.fish.gotoAndStop(clr + '0');
	this.fish_tween = createjs.Tween.get(this.fish).to({alpha:1}, 500).call(this.fishTweenDone.bind(this));		

};

// used to trigger the next event when the tween is done
p.fishTweenDone = function() {
	this.ev_disp.trigger('ANSWER_DISPLAYED');
};

// used to clear the object
p.clearObject = function() {
	this.fish.stop();
	this.bubbles.stop();
	if(typeof this.animtimer !== 'undefined') {
		this.animtimer.destroy();	
	}
	if(typeof this.bubble_timer !== 'undefined') {
		this.bubble_timer.destroy();	
	}
	while(this.view.numChildren > 0) {
		this.view.removeChildAt(0);
	}
	this.fish = null;
	this.bubbles = null;
	this.view = null;
};
